// @flow

import { B400 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';

import HeaderContent from '../../../../../../../common/components/Header/components/HeaderContent';
import PartnerQuickLinks from './PartnerQuickLinks/components/PartnerQuickLinks/PartnerQuickLinks';

import type { BrowserHistory } from 'history/createBrowserHistory';
import type { Map } from 'immutable';
import type { Node } from 'react';

const HeaderContainer = styled.header`
  position: relative;
  background-color: ${B400};
  min-height: 70px; // here to ensure that the header always has some height so there is less flashing
`;

type HeaderProps = {|
  getUserData: () => void,
  onLogout: () => void,
  userData: Map,
  children?: Node,
  history: BrowserHistory,
  displayPartnerQuickLinks: boolean,
  onSwitchAccount: () => void,
|};

const Header = (props: HeaderProps) => {
  const {
    displayPartnerQuickLinks,
    userData,
    getUserData,
    onLogout,
    history,
    children = null,
    onSwitchAccount,
  } = props;
  return (
    <>
      {displayPartnerQuickLinks && <PartnerQuickLinks userData={userData} />}
      <HeaderContainer role="banner">
        <HeaderContent
          getUserData={getUserData}
          onLogout={onLogout}
          userData={userData}
          history={history}
          onSwitchAccount={onSwitchAccount}
        >
          {children}
        </HeaderContent>
      </HeaderContainer>
    </>
  );
};

export default Header;
